// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mOverflowYAuto {\n  overflow-y: auto;\n}\n\n.mMinWidth170 {\n  min-width: 170px;\n}\n", ""]);
// Exports
module.exports = exports;
